import {IRange} from "../types/IRange";
import {RangeType} from "../types/RangeType";

export const changeValue = (value: IRange<RangeType>, min: number, max: number) => {
    const values = [value?.lower, value?.upper].filter((value) => Number.isFinite(Number(value))) as number[];
    if (values.length === 0) {
        return [min];
    }
    if (values.length === 1 && values[0] >= min && values[0] <= max) {
        return values;
    }
    if (values.length === 2 && values[0] >= min && values[1] > max) {
        if (values[0] > max) {
            return [max, max];
        }
        return [values[0], max];
    }
    if (values.length === 2 && values[0] >= min && values[1] <= max) {
        if (values[0] > values[1]) {
            return [values[1], values[1]];
        }
        return values;
    }

    return null;
};
